import { RouterProvider, createRouter } from '@tanstack/react-router';
import { QueryProvider } from '@/features/dashboard/providers/QueryProvider';
import { ThemeProvider } from '@/theme';

// Import the generated route tree
// Note: TanStack Router CLI generates this file from your route files
import { routeTree } from './routeTree.gen';

/**
 * Create the router instance
 *
 * The router is created from the route tree generated by TanStack Router.
 * Route tree is auto-generated from files in src/routes/ directory.
 */
const router = createRouter({ routeTree });

/**
 * Type declaration for router
 *
 * This enables TypeScript autocomplete for route paths and params.
 */
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router;
  }
}

/**
 * Main App Component
 *
 * Provides the application context with:
 * - ThemeProvider for MUI styling with dark mode support (Phase 5C)
 * - TanStack Query for data fetching and caching
 * - TanStack Router for navigation
 *
 * Provider Hierarchy:
 * ```
 * ThemeProvider (MUI styling + dark mode)
 *   └─ QueryProvider (data fetching)
 *      └─ RouterProvider (navigation)
 *         └─ Routes (your components)
 * ```
 *
 * The router will render the appropriate route component based on the URL,
 * starting with __root.tsx which contains the ErrorBoundary.
 */
export function App() {
  return (
    <ThemeProvider>
      {/* QueryProvider for TanStack Query with React Query DevTools */}
      <QueryProvider>
        {/* RouterProvider for TanStack Router navigation */}
        <RouterProvider router={router} />
      </QueryProvider>
    </ThemeProvider>
  );
};

export default App;
